export default __webpack_public_path__ + "static/farmacia_lusitana_white_full-79e787e53c3273bc7c32978f0e7fcb17.svg";